var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.667 8.667h6.666M22 7.889v11.889A2.222 2.222 0 0 1 19.778 22H4.222A2.222 2.222 0 0 1 2 19.778V7.888c0-.878.517-1.673 1.32-2.03L12 2l8.68 3.858A2.222 2.222 0 0 1 22 7.888ZM9.778 14.222h4.444c.614 0 1.111.498 1.111 1.111V22H8.667v-6.667c0-.613.497-1.11 1.11-1.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8a4af5c00c733cfd306ec65490b5cce7.svg";
export { ForwardRef as ReactComponent };